import React, { useState, useEffect } from "react";
import Select from "react-select";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import Modal from "Common/Components/Modal";
import VillageSelect from "../AllComponetnReadyLoad/VillageSelect";
interface CommitModalProps {
  show: boolean;
  toggle: () => void;
  validation: any;
  dataListProvince: any[];
  dataListCity: any[];
  dataListVillage: any[];
  dataListFarmer: any[];
  ProvinceID: any;
  setProvinceID: (id: number | string) => void;
  CityID: any;
  setCityID: (id: number | string) => void;
  dataListVillageID: any;
  setdataListVillageID: (id: any) => void;
  FarmerID: any;
  setFarmerID: (id: number | string) => void;
  Datevalues: any;
  setDatevaluesValues: (date: any) => void;
  YearCoptSelect: string;
  handleClick: (e?: any) => void;
  isLoadingBtn?: boolean;
  searchValueSelect?: string;
  setSearchProvinceSelect?: (value: string) => void;
  setSearchCitySelect?: (value: string) => void;
  setSearchVilageSelect?: (value: string) => void;
  setsearchvalesearchvalueSelect?: (value: string) => void;
}

const CommitModal: React.FC<CommitModalProps> = ({
  show,
  toggle,
  validation,
  dataListProvince = [],
  dataListCity = [],
  dataListVillage = [],
  dataListFarmer = [],
  ProvinceID,
  setProvinceID,
  CityID,
  setCityID,
  dataListVillageID,
  setdataListVillageID,
  FarmerID,
  setFarmerID,
  Datevalues,
  setDatevaluesValues,
  YearCoptSelect,
  handleClick,
  isLoadingBtn = false,
  searchValueSelect = "",
  setSearchProvinceSelect = () => {},
  setSearchCitySelect = () => {},
  setSearchVilageSelect = () => {},
  setsearchvalesearchvalueSelect = () => {},
}) => {
  const [selectedFarmer, setSelectedFarmer] = useState<any | null>(null);
  const [searchInputValue, setSearchInputValue] = useState(searchValueSelect);
  const [selectedVilage, setselectedVilage] = useState(null);

  // همگام سازی مقدار جستجو با prop
  useEffect(() => {
    setSearchInputValue(searchValueSelect);
  }, [searchValueSelect]);

  // همگام سازی انتخاب کشاورز با FarmerID
  useEffect(() => {
    if (FarmerID) {
      const farmer = dataListFarmer.find((item) => item.id == FarmerID);
      if (farmer) {
        setSelectedFarmer({
          value: farmer.id,
          label: farmer.full_name || "",
        });
      }
    } else {
      setSelectedFarmer(null);
    }
  }, [FarmerID, dataListFarmer]);

  useEffect(() => {
    if (!show) {
      setselectedVilage(null);
      setdataListVillageID(null);
    }
  }, [show]);

  if (!show) {
    return null;
  }
  return (
    <Modal
      show={show}
      onHide={toggle}
      modal-center="true"
      className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
      dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600"
    >
      <Modal.Header
        className="flex items-center justify-between p-4 border-b dark:border-zink-500"
        closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
      >
        <Modal.Title className="text-16">ثبت قرارداد جدید</Modal.Title>
      </Modal.Header>

      <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
        <form
          className="create-form"
          id="create-form"
          onSubmit={validation.handleSubmit}
        >
          <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
            <div className="xl:col-span-11 dark:text-white text-gray-800 space-y-4">
              {/* ردیف اول: اطلاعات پایه */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* شماره قرارداد */}
                {/* <div className="flex flex-col gap-2">
                  <label
                    htmlFor="commitment_number"
                    className="text-base font-medium dark:text-white"
                  >
                    شماره قرارداد:
                  </label>
                  <input
                    type="number"
                    id="commitment_number"
                    name="commitment_number"
                    className="w-full p-2 border border-gray-200 rounded bg-white text-gray-900 dark:text-white dark:bg-[#132337]"
                    placeholder="0"
                    onChange={validation.handleChange}
                    value={validation.values.commitment_number}
                  />
                  {validation.touched.commitment_number &&
                    validation.errors.commitment_number && (
                      <p className="text-red-400 mt-1">
                        {validation.errors.commitment_number}
                      </p>
                    )}
                </div> */}

                {/* استان */}
                <div className="flex flex-col gap-2">
                  <label
                    htmlFor="province"
                    className="text-base font-medium dark:text-white"
                  >
                    استان:
                  </label>
                  <Select<any>
                    value={
                      ProvinceID
                        ? {
                            value: ProvinceID,
                            label:
                              dataListProvince.find(
                                (item) => item.id === ProvinceID
                              )?.province || "",
                          }
                        : null
                    }
                    options={dataListProvince.map((item) => ({
                      value: item.id,
                      label: item.province || "",
                    }))}
                    onChange={(selected) =>
                      selected && setProvinceID(selected.value)
                    }
                    onInputChange={setSearchProvinceSelect}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      control: (base, state) => ({
                        ...base,
                        backgroundColor: "inherit",
                        boxShadow: state.isFocused
                          ? "0 0 0 1px #2684FF"
                          : "none",
                      }),
                      option: (base, state) => ({
                        ...base,
                        color: "inherit",
                        "&:hover": {
                          backgroundColor: "#2684FF",
                        },
                      }),
                    }}
                    menuPortalTarget={document.body}
                    placeholder="جستوجو..."
                    noOptionsMessage={() => "داده‌ای دریافت نشد"}
                    loadingMessage={() => "در حال بارگذاری..."}
                    className="w-full my-react-select-container dark:text-white"
                    classNamePrefix="my-react-select"
                    maxMenuHeight={300}
                    isSearchable
                  />
                </div>

                {/* شهرستان */}
                <div className="flex flex-col gap-2">
                  <label
                    htmlFor="city"
                    className="text-base font-medium dark:text-white"
                  >
                    شهرستان:
                  </label>
                  <Select<any>
                    value={
                      CityID
                        ? {
                            value: CityID,
                            label:
                              dataListCity.find((item) => item.id === CityID)
                                ?.city || "",
                          }
                        : null
                    }
                    options={dataListCity.map((item) => ({
                      value: item.id,
                      label: item.city || "",
                    }))}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      control: (base, state) => ({
                        ...base,
                        backgroundColor: "inherit",
                        boxShadow: state.isFocused
                          ? "0 0 0 1px #2684FF"
                          : "none",
                      }),
                      option: (base, state) => ({
                        ...base,
                        color: "inherit",
                        "&:hover": {
                          backgroundColor: "#2684FF",
                        },
                      }),
                    }}
                    onInputChange={setSearchCitySelect}
                    onChange={(selected) =>
                      selected && setCityID(selected.value)
                    }
                    menuPortalTarget={document.body}
                    placeholder="جستوجو..."
                    noOptionsMessage={() => "داده‌ای دریافت نشد"}
                    loadingMessage={() => "در حال بارگذاری..."}
                    className="w-full my-react-select-container dark:text-white"
                    classNamePrefix="my-react-select"
                    maxMenuHeight={300}
                    isSearchable
                  />
                </div>

                {/* روستا */}
                <div className="flex flex-col gap-2">
                  <label
                    htmlFor="city"
                    className="text-base font-medium dark:text-white"
                  >
                    روستا:
                  </label>
                  <Select
                    value={selectedVilage}
                    options={dataListVillage.map((item) => ({
                      value: item.id,
                      label: item.village || "بدون نام",
                    }))}
                    onInputChange={(inputValue) => {
                      setSearchVilageSelect(inputValue);
                    }}
                    onChange={(selected: any) => {
                      setselectedVilage(selected);
                      if (selected) {
                        setdataListVillageID(selected?.value || "");
                      }
                    }}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      control: (base, state) => ({
                        ...base,
                        backgroundColor: "inherit",
                        boxShadow: state.isFocused
                          ? "0 0 0 1px #2684FF"
                          : "none",
                      }),
                      option: (base, state) => ({
                        ...base,
                        color: "inherit",
                        "&:hover": {
                          backgroundColor: "#2684FF",
                        },
                      }),
                      input: (base) => ({
                        // اطمینان از نمایش input
                        ...base,
                        color: "inherit",
                      }),
                    }}
                    menuPortalTarget={document.body}
                    placeholder="جستوجو..."
                    noOptionsMessage={() => "داده‌ای دریافت نشد"}
                    loadingMessage={() => "در حال بارگذاری..."}
                    className="w-full my-react-select-container dark:text-white"
                    classNamePrefix="my-react-select"
                    maxMenuHeight={300}
                    isSearchable={true}
                    isClearable={true} // افزودن دکمه پاک کردن
                  />
                </div>
              </div>

              {/* ردیف دوم: اطلاعات کمی */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* کشاورز */}
                <div className="flex flex-col gap-2">
                  <label
                    htmlFor="farmer"
                    className="text-base font-medium dark:text-white"
                  >
                    کشاورز:
                  </label>
                  <Select<any>
                    value={selectedFarmer}
                    options={dataListFarmer.map((f) => ({
                      value: f.id,
                      label: f.full_name || "",
                    }))}
                    onChange={(selected) => {
                      setSelectedFarmer(selected);
                      if (selected) {
                        setFarmerID(selected.value);
                      }
                    }}
                    onInputChange={(inputValue) => {
                      setSearchInputValue(inputValue);
                      setsearchvalesearchvalueSelect(inputValue);
                    }}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      control: (base, state) => ({
                        ...base,
                        backgroundColor: "inherit",
                        boxShadow: state.isFocused
                          ? "0 0 0 1px #2684FF"
                          : "none",
                      }),
                      option: (base, state) => ({
                        ...base,
                        color: "inherit",
                        "&:hover": {
                          backgroundColor: "#2684FF",
                        },
                      }),
                    }}
                    menuPortalTarget={document.body}
                    inputValue={searchInputValue}
                    placeholder="جستوجو..."
                    noOptionsMessage={() => "داده‌ای دریافت نشد"}
                    loadingMessage={() => "در حال بارگذاری..."}
                    className="w-full my-react-select-container dark:text-white"
                    classNamePrefix="my-react-select"
                    maxMenuHeight={300}
                    isSearchable
                  />
                </div>

                {/* میزان تن برداشتی */}
                <div className="flex flex-col gap-2">
                  <label
                    htmlFor="withdrawal_amount"
                    className="text-base font-medium dark:text-white"
                  >
                    میزان تن برداشتی:
                  </label>
                  <input
                    type="number"
                    id="withdrawal_amount"
                    name="withdrawal_amount"
                    className="w-full p-2 border border-gray-200 rounded bg-white text-gray-900 dark:text-white dark:bg-[#132337]"
                    placeholder="0"
                    onChange={validation.handleChange}
                    value={validation.values.withdrawal_amount}
                  />
                  {validation.touched.withdrawal_amount &&
                    validation.errors.withdrawal_amount && (
                      <p className="text-red-400 mt-1">
                        {validation.errors.withdrawal_amount}
                      </p>
                    )}
                </div>

                {/* زمین (هکتار) */}
                <div className="flex flex-col gap-2">
                  <label
                    htmlFor="amount_of_land"
                    className="text-base font-medium dark:text-white"
                  >
                    زمین (هکتار):
                  </label>
                  <input
                    type="number"
                    id="amount_of_land"
                    name="amount_of_land"
                    className="w-full p-2 border border-gray-200 rounded bg-white text-gray-900 dark:text-white dark:bg-[#132337]"
                    placeholder="0"
                    onChange={validation.handleChange}
                    value={validation.values.amount_of_land}
                  />
                  {validation.touched.amount_of_land &&
                    validation.errors.amount_of_land && (
                      <p className="text-red-400 mt-1">
                        {validation.errors.amount_of_land}
                      </p>
                    )}
                </div>

                {/* تاریخ */}
                <div className="flex flex-col gap-2">
                  <label className="text-base font-medium dark:text-white">
                    تاریخ برداشت:
                  </label>
                  <DatePicker
                    calendar={persian}
                    locale={persian_fa}
                    value={Datevalues}
                    onChange={setDatevaluesValues}
                    format="YYYY/MM/DD"
                    calendarPosition="bottom-right"
                    containerClassName="w-full"
                    inputClass="form-input w-full p-2 border border-gray-200 rounded bg-white text-gray-900 dark:text-white dark:bg-[#132337]"
                  />
                </div>

                <div className="">
                  سال زراعی انتخاب شده:
                  <span className="text-custom-600 dark:text-gray-200 bold">
                    {YearCoptSelect ? YearCoptSelect : ""}{" "}
                  </span>{" "}
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>

      <Modal.Footer className="flex justify-center p-4 border-t dark:border-zink-500">
        <button
          type="button"
          onClick={handleClick}
          className="px-4 py-2 mt-4 font-bold justify-end text-white bg-blue-500 rounded hover:bg-blue-600"
        >
          {isLoadingBtn ? "در حال ارسال..." : "ثبت اطلاعات"}{" "}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CommitModal;
